import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { accountSelector } from '@/store';
import { getProjectSelectorUsers } from '../api/project-selector-users';

export function useProjectSelectorUsers() {
  const { data: account } = useSelector(accountSelector);
  return useQuery({
    queryKey: ['GET_USERS', 'sherpa', 'project-selectors', account.id, account.subdomain],
    queryFn: getProjectSelectorUsers,
    enabled: account.id > 0,
    staleTime: 30_000,
  });
}
